import React, {
	useEffect
}from "react"
import {
	Form, Checkbox
}from "antd"
import {
	useDispatch, useSelector
}from "react-redux"
import {
	userActions
}from "../../store/actions/user"
import i18n from "./localization"
import "./style.scss"

const RolesFormPart = (props) => {
	const { userId } = props
	const dispatch = useDispatch()
	const { rolesDto } = useSelector((state) => state.userReducer)
	const isRu = useSelector((state) => state.globalReducer.isRu)

	useEffect(() => {
		dispatch(userActions.getRoles({ userId }))
		return () => {
			dispatch(userActions.clearRoles())
		}
	}, [])

	return (
		<Form.Item
			className="roles-register-by-admin"
			label={ i18n.rolesTitle[isRu] }
		>
			{ Boolean(rolesDto?.length) && (
				<>
					{ rolesDto.map((role, index) => {
						return (
							<div key={ role.id }>
								<Form.Item
									initialValue={ role.checked }
									name={ [
										"roles",
										index,
										"checked"
									] }
									valuePropName="checked"
								>
									<Checkbox>
										{ role[`description${ isRu ? "" : "Bel" }`] }
									</Checkbox>
								</Form.Item>
								<Form.Item
									hidden
									initialValue={ role.id }
									name={ [
										"roles",
										index,
										"id"
									] }
								/>
							</div>
						)
					}) }
				</>
			) }
		</Form.Item>
	)
}

export default RolesFormPart
